import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { StyledDescription } from './style';

interface DescriptionProps {
  text: string;
  showMore?: boolean; // If true, truncation + toggle button are enabled
}

const CHARACTER_LIMIT = 450;

export const DescriptionWithShowMore: React.FC<DescriptionProps> = ({ text, showMore = false }) => {
  const [showFull, setShowFull] = useState(false);
  const intl = useIntl();

  if (!text) return null;

  const isLongText = text.length > CHARACTER_LIMIT;
  const shouldTruncate = showMore && isLongText && !showFull;
  const displayedText = shouldTruncate ? text.slice(0, CHARACTER_LIMIT) + '...' : text;

  const toggleShow = () => setShowFull(prev => !prev);

  return (
    <StyledDescription className="desc">
      {displayedText}
      {showMore && isLongText && (
        <span className="show-toggle" onClick={toggleShow}>
          {showFull
            ? intl.formatMessage({ id: 'description.show_less', defaultMessage: 'Show less' })
            : intl.formatMessage({ id: 'description.show_all', defaultMessage: 'Show all' })}
        </span>
      )}
    </StyledDescription>
  );
};
